import { getCSRFToken } from './csrf';

let appBridgeReady = false;

export async function getFetch(url:string, body:any, signal?: AbortSignal) {
  const sessionToken = await getSessionTokenFromAppBridge();
  url = addSlashToURLWhereNecessary(url);
  return fetch(url, {
      credentials: 'include',
      method: 'GET',
      mode: 'same-origin',
      signal,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
  });
}

export async function postFetch(url:string, body:any) {
  let sessionToken: string;
  try {
    sessionToken = await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
    return fetch(url, {
        credentials: 'include',
        method: 'POST',
        mode: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': getCSRFToken(),
          'Authorization': 'Bearer ' + sessionToken
        },
        body: JSON.stringify(body)
    });
}

export async function deleteFetch(url:string, body:any) {
  let sessionToken: string;
  try {
    sessionToken = await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
  return fetch(url, {
      credentials: 'include',
      method: 'DELETE',
      mode: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
      body: JSON.stringify(body)
  });
}

export async function putFetch(url:string, body:any) {
  let sessionToken: string;
  try {
    sessionToken = await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
  console.log('putFetch: sending PUT to', url);
  const response = await fetch(url, {
      credentials: 'include',
      method: 'PUT',
      mode: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
      body: JSON.stringify(body)
  });
  console.log('putFetch: response received, status:', response.status);
  return response;
}
export async function patchFetch(url:string, body:any) {
  let sessionToken: string;
  try {
    sessionToken = await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
  return fetch(url, {
      credentials: 'include',
      method: 'PATCH',
      mode: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
      body: JSON.stringify(body)
  });
}

export class ApiError extends Error {
  constructor(public status: number) {
    super('Request failed (' + status + ')');
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

// Bound the complete read, including authorization and the response body.
// Callers retain their current UI and offer a retry when this rejects.
export async function getJson(url: string): Promise<any> {
  const controller = new AbortController();
  let timeout: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      getFetch(url, {}, controller.signal).then(response => {
        // Django's login decorator can redirect before the API view runs.
        // Fetch follows it, and the login page may return HTML or even a 500
        // without the embedded shop context. Offer authentication recovery.
        if (response.redirected && response.url) {
          const destination = new URL(response.url, window.location.href);
          if (destination.origin === window.location.origin && /^\/app\/login\/?$/.test(destination.pathname)) {
            throw new ApiError(401);
          }
        }
        if (!response.ok) throw new ApiError(response.status);
        return response.json();
      }),
      new Promise<never>((_, reject) => {
        timeout = setTimeout(() => {
          reject(new Error('request_timeout'));
          controller.abort();
        }, 30000);
      })
    ]);
  } finally {
    if (timeout !== undefined) clearTimeout(timeout);
  }
}

export async function initAppBridge() {
  if (appBridgeReady) return;
  appBridgeReady = true;
}

async function getSessionTokenFromAppBridge() {
  await initAppBridge();
  let timeout: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race<string>([
      (window as any).shopify.idToken(),
      new Promise<never>((_, reject) => {
        timeout = setTimeout(() => reject(new Error('idToken_timeout')), 10000);
      })
    ]);
  } finally {
    if (timeout !== undefined) clearTimeout(timeout);
  }
}

function addSlashToURLWhereNecessary(url: string) {
  if (!url.endsWith('/') && url.indexOf('?') === -1) {
    return url + '/';
  } else {
    return url;
  }
}
